/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamSkupinaFunkci extends GContentBase<SeznamSkupinaFunkciObj> {
        private seznamObj: SeznamSkupinaFunkciObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamSkupinaFunkciObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamSkupinaFunkciNew",
                contentCaption: "jres:33000886", //RC 33000886 : Skupiny funkc�
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_sfu}"
                },
                gridSettings: {
                    columnOrder: "nazev,zkratka,poznamka,ixs_sfu,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamSkupinaFunkciObj extends GAdmSeznamBase {

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailSkupinaFunkci", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailSkupinaFunkci",
                newRecord: isNew,
                ixs_sfu: isNew == true ? null : data.ixs_sfu
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSkupinaFunkciClen: {
                    icon: "fa-link",
                    caption: "jres:33000889",
                    run: () => {
                        this.openSkupinaFunkciClen();
                    }
                },
                actOpenSkupinaFunkciOpravneni: {
                    icon: "fa-link",
                    caption: "jres:33000891",
                    run: () => {
                        this.openSkupinaFunkciOpravneni();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*", {
                favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                    { action: this.cnt.actions.actOpenSkupinaFunkciClen },
                    { action: this.cnt.actions.actOpenSkupinaFunkciOpravneni }
                ]
            }]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*",
                "actOpenSkupinaFunkciClen*",
                "actOpenSkupinaFunkciOpravneni*"
            ])
        }

        createFilterForm() {
           
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.SkupinaFunkci.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenSkupinaFunkciClen?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSkupinaFunkciOpravneni?.update({ enabled: objArr.count == 1 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_sfu}`,
                nazev: data["nazev"]
            }
        }

        private openSkupinaFunkciClen() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamSkupinaFunkciClen", { ixs_sfu: activeRow.ixs_sfu })
        }

        private openSkupinaFunkciOpravneni() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamSkupinaFunkciOpravneni", { ixs_sfu: activeRow.ixs_sfu })
        }
    }
}